import classNames from 'clsx';
import React from 'react';

import ModalProvider from '@swf/core/providers/ModalProvider';
import type { ClassNameProp } from '@swf/core/types/Props';

import type { HelpSection } from '../../types/Cashier';
import ErrorHandler from '../ErrorHandler/ErrorHandler';
import HelpSectionContainer from '../HelpSectionContainer/HelpSectionContainer';

import { gridLayout, layout, leftSection, rightSection } from './Layout.scss';
import Footer from './components/Footer/Footer';
import type { HeaderPropsProp } from './components/Header/Header';
import Header from './components/Header/Header';

type Props = Partial<ClassNameProp> &
  HeaderPropsProp & {
    showFooter?: boolean;
    applyGridLayout?: boolean;
    helpSection?: HelpSection;
    limitsSection?: HelpSection;
  };

const Layout: React.FunctionComponent<Props> = ({
  children,
  className,
  headerProps,
  showFooter,
  applyGridLayout,
  helpSection,
  limitsSection
}) => (
  <ModalProvider>
    <ErrorHandler>
      <div className={classNames(layout, className, { [gridLayout]: applyGridLayout })}>
        <Header {...headerProps} />
        {applyGridLayout ? (
          <div className={classNames({ [gridLayout]: applyGridLayout })}>
            <section>
              <div className={rightSection}>
                <main>{children}</main>
              </div>
              <div className={leftSection}>
                <HelpSectionContainer helpSection={helpSection} />
                {limitsSection && <HelpSectionContainer helpSection={limitsSection} />}
              </div>
            </section>
          </div>
        ) : (
          <section>
            <main>{children}</main>
          </section>
        )}
      </div>
      <Footer showFooter={showFooter} modal={headerProps.modal} />
    </ErrorHandler>
  </ModalProvider>
);

export default Layout;
